import { useCallback } from 'react';
import { useRequest } from 'ahooks';
import { Options } from 'ahooks/lib/useRequest/src/types';
import { AxiosResponse } from 'axios';

import { apiGet } from 'api';

import { useGetHeaders } from 'hooks';

import {
  IApiHookRequestParams,
  IApiRequestParams,
  TRequestCallback,
  TResponse,
} from 'types';

import { handleRequest } from './handleRequest';

export const useGetLazyRequest = <R, P = undefined>(opts?: IApiHookRequestParams<R, IApiRequestParams<P>>): [
  request: TRequestCallback<P>,
  response: TResponse<R, IApiRequestParams<P>>
] => {
  const {
    url,
    options,
    baseURL,
    queryParams,
  } = opts || {};

  const {
    run,
    data,
    ...rest
  } = useRequest<AxiosResponse<R, P>, [IApiRequestParams<P>]>(
    apiGet,
    { ...options, manual: true } as Options<AxiosResponse<R>, [IApiRequestParams<P>]>,
  );

  const headers = useGetHeaders();

  const handleLazyGetRequest = useCallback(handleRequest({
    run,
    url,
    baseURL,
    headers,
    queryParams,
  }), [url, headers]);

  return [
    handleLazyGetRequest,
    {
      ...rest,
      data: data?.data,
    } as TResponse<R, IApiRequestParams<P>>,
  ];
};
